export default {
  common: {
    formFields: {
      firstName: 'First name',
      lastName: 'Last name',
      secondLastName: 'Second last Name',
      email: 'Email',
      phone: 'Phone',
      birthYear: 'Birth year',
      birthDate: 'Birth date',
      postalCode: 'Postal code',
      gender: 'Gender',
      title: 'Title',
      address: 'Address',
      company: 'Company name',
      password: 'Password',
      passwordConfirmation: 'Password confirmation',
      remember: 'Remember',
      communications: 'I want to receive platform updates and promotions by email.',
      country: 'Country',
      emojiReaction: 'Emoji reaction',
      interests: 'Interests',
      fields: {
        optional: '(optional)'
      }
    },
    pay: 'Place order',
    cv19certificate: 'Download Certificate of Mobility CV-19',
    gender: {
      female: 'Female',
      male: 'Male',
      notDefined: 'Not defined'
    },
    title: {
      mr: 'Mr.',
      ms: 'Ms.'
    },
    agreement: {
      yes: 'Yes',
      no: 'No'
    },
    languages: {
      es_ES: 'Español',
      en_GB: 'English'
    },
    emojiReactions: {
      wow: 'Wow',
      love: 'Love',
      lolCry: 'Crying of laughter',
      wuaa: 'Wuaa',
      fun: 'Fun',
      lol: 'Lol',
      kiss: 'Kiss',
      cry: 'Sad',
      lovely: 'Lovely',
      angry: 'Angry',
      sleep: 'Sleep',
      winking: 'Winking',
      yeah: 'Yeah',
      no: 'No',
      cuteSad: 'Cute sad',
      nerd: 'Nerd',
      yes: 'Yes'
    },
    notifications: {
      titles: {
        info: 'Information',
        success: 'Success',
        warning: 'Warning',
        error: 'Error'
      },
      messages: {
        requestError: 'An error occurred while processing your request. Try again later.',
        fullCapacity: 'Thank you very much for your interest. At this time the capacity is full. If you wish, you can continue with the registration to be part of the waiting list. If any place is released, we will inform you.',
        noMoreTickets: 'Thank you very much for your interest. At this time the capacity is full.'
      }
    },
    confirmInvitation: {
      terms: {
        base: 'I accept the {platform}.',
        platform: 'Terms and Condicions of the Platform'
      },
      privacy: {
        base: 'I accept the {privacy}.',
        privacy: 'Privacy Policy'
      },
      sections: {
        basicInfo: {
          title: 'Sign up to access your events'
        },
        processorAgreement: {
          title: 'Contrato de encargado de tratamiento de datos personales',
          accept: 'Acepto el contrato de encargado de tratamiento'
        },
        success: {
          title: '%{name} can now access your events.',
          action: 'Login'
        },
        error: {
          notFound: {
            text: 'Invitation not found. Check the URL that you\'re trying to access or contact with the event admin.',
            verificationCode: 'Your verification code is: %{code}'
          },
          server: {
            text: 'Wow! We had a problem when connecting to the server. Try again later.'
          }
        }
      },
      privacyLegend: {
        terms: {
          info: 'INFORMACIÓN SOBRE PROTECCIÓN DE DATOS DE YUMIWI DATA S.L.,',
          purposes: {
            title: 'Finalidades:',
            text: 'Activar la Cuenta Cliente para la utilización de la Plataforma Yumiwi. '
          },
          legitimation: {
            title: 'Legitimación:',
            text: 'Consentimiento del interesado y el interés legítimo del Responsable del Tratamiento.'
          },
          recipients: {
            title: 'Destinatarios:',
            text: 'La información proporcionada podrá ser compartida con nuestra base de datos de almacenamiento y terceros proveedores de servicios.'
          },
          rights: {
            title: 'Derechos:',
            text: ' Puede retirar su consentimiento en cualquier momento, así como acceder, rectificar, suprimir sus datos y demás derechos en {action}, sin perjuicio de lo establecido en el contrato de prestación de servicios mantenido entre usted y el Responsable del Tratamiento.'
          }
        }
      },
      actions: {
        next: 'Next',
        cancel: 'Cancel',
        signUp: 'Sign up'
      }
    },
    dates: {
      seconds: 'a second ago | {unit} seconds ago',
      minutes: 'a minute ago | {unit} minutes ago',
      hours: 'an hour ago | {unit} hours ago',
      days: 'a day ago | {unit} days ago',
      months: 'a month ago | {unit} months ago',
      years: 'a year ago | {unit} years ago'
    }
  },
  event: {
    invitation: {
      unpublish: 'Invitation is not published. Publish it to give access to the guest.'
    },
    registration: {
      unpublish: 'Registration is not published. Publish it to give access to the guest.',
      invalidToken: 'Sorry. This link has already been used or is invalid.'
    },
    timeline: {
      download: 'Download',
      unpublish: 'Timeline is not published. Publish it to give access to the attendee',
      broadcast: {
        interestsFlag: 'Because you are interested in: '
      },
      socials: {
        share: 'Share',
        facebook: 'Share with Facebook',
        twitter: 'Share with Twitter',
        linkedIn: 'Share with LinkedIn',
        whatsapp: 'Share with Whatsapp',
        email: 'Share by Email'
      },
      expressions: {
        love: 'Love',
        lolCry: 'Haha',
        wow: 'Wow',
        cry: 'Sad',
        angry: 'Angry'
      },
      eventFeedback: {
        buttonActions: {
          send: 'Send',
          remove: 'Remove'
        }
      },
      scratchAndWin: {
        buttonActions: {
          check: 'Check',
          reset: 'One more time!'
        },
        reaction: {
          won: {
            title: 'You\'ve won!',
            reward: 'Pick up your "%{reward}" showing the code %{code}.'
          },
          lost: {
            title: 'What a pity!',
            noReward: 'The code %{code} has no reward.',
            tryAgain: 'You can always try again.'
          }
        },
        errors: {
          invalid: 'The code %{code} is invalid.',
          alreadyUsed: 'The code %{code} is already used.'
        }
      },
      raffle: {
        statuses: {
          thankYou: 'Thank you for your participation!',
          noGift: 'There are no gifts left.'
        },
        reaction: {
          won: 'You\'ve won!',
          lost: 'What a pity!'
        }
      },
      question: {
        buttonActions: {
          answer: 'Answer'
        },
        messages: {
          thanksToResponse: 'Thank you very much for answering.',
          answer: 'Your answer: %{answer}.',
          timeOver: 'We are sorry, but the time to answer is over.'
        }
      },
      buttonActions: {
        save: 'Save',
        signIn: 'Sign in'
      },
      labels: {
        images: 'Images',
        videos: 'Videos',
        gifts: 'Gifts',
        files: 'Files',
        downloads: 'Downloads',
        gifs: 'Memes',
        announces: 'Advertisements'
      },
      zoomMeeting: {
        title: 'Your Zoom meeting starts in',
        button: 'Join the Zoom meeting',
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds'
      }
    }
  }
}
